import { useState } from 'react';
import classNames from 'classnames/bind';
import styles from './FileRelease.module.css';

import { useAppSelector } from '../../../../hooks/useRedux';
import { selectLibSingleItem } from '../../../../features/librarySlice';

import Item from '../Item';
import {
  INPUT_KEYWORD,
  KEYWORD,
  PRIVATE,
  PUBLIC,
  SETUP,
} from '../../../../constants';
import Input from '../../../Input';

interface FileRelease {
  id: string;
}

export default function FileRelease({ id }: FileRelease) {
  const cx = classNames.bind(styles);
  const item = useAppSelector(selectLibSingleItem);
  const projectPublic = item?.projectPublic;
  if (!projectPublic) return null;

  const { publicYn, publicKeyword1, publicKeyword2, publicKeyword3 } =
    projectPublic;

  const [isPublic, setIsPublic] = useState(publicYn);
  const radioValues = [!isPublic, isPublic];
  const keywords = [publicKeyword1, publicKeyword2, publicKeyword3];

  const handleRadio = (e: React.ChangeEvent<HTMLInputElement>) =>
    setIsPublic(+!isPublic);

  const ReleaseSetting = (
    <>
      {radioValues.map((value, i) => (
        <div key={i} className={cx('radio_wrap')}>
          <label>
            <Input
              type="radio"
              id="publicYn"
              value={+value}
              isHidden={true}
              checked={!!value}
              onChange={handleRadio}
            >
              <span className={cx('rlabel')}>{i ? PUBLIC : PRIVATE}</span>
            </Input>
          </label>
        </div>
      ))}
    </>
  );

  const KeywordSetting = (
    <>
      <div className={cx('desc')}>{INPUT_KEYWORD}</div>
      <div className={cx('input_box')}>
        {keywords.map((keyword, i) => (
          <div key={i} className={cx('keyword_area')}>
            <Input
              type="text"
              id={`publicKeyword${i + 1}`}
              value={keyword ?? ''}
              placeholder={`${KEYWORD}${i + 1}`}
              classnames={['input_t', 'w100', 'keyword']}
              limit={5}
            />
          </div>
        ))}
      </div>
    </>
  );

  const settings = [
    { title: PUBLIC, children: ReleaseSetting },
    { title: KEYWORD, children: KeywordSetting },
  ];

  return (
    <>
      {settings.map(({ title, children }, i) => (
        <Item key={title} id={id} title={`${title} ${SETUP}`}>
          <div className={cx('panel_row', i ? 'column' : 'row_center')}>
            {children}
          </div>
        </Item>
      ))}
    </>
  );
}
